import { enWebhookDeliveries } from "./enWebhookDeliveries";

/** Integrations → Webhooks, the delivery status column (PREC-4248). */
export const enWebhookHealth = {
	column: "Status",
	state: {
		paused: "Paused",
		failing: "Failing",
		lastFailed: "Last delivery failed",
		retrying: "Retrying",
		delivering: "Delivering",
		idle: "No deliveries yet",
	},
	errorSince: "{{error}} since {{since}}",
	since: "Since {{since}}",
	lastDelivered: "Last delivered {{date}}",
	lastFailed: "Last failed {{date}}",
	resume: "Resume",
	resumeFailed: "The webhook could not be resumed. Please try again.",
	/** The Deliveries page and its entry points (PREC-4250). */
	deliveries: enWebhookDeliveries,
};
